import { useTranslation } from 'next-i18next/pages';

import { Button, Collapse } from 'antd';

import { TranslationNamespace } from '@/i18n';

import { type CalculationResult, formatRub } from '../../lib';

import { BreakdownTable } from './BreakdownTable';
import { ScenarioCards } from './ScenarioCards';
import { TariffCard } from './TariffCard';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface ResultsProps {
	companyName: string;
	result: CalculationResult;
	onEdit: () => void;
	onShowChart: () => void;
}

export function Results({ companyName, result, onEdit, onShowChart }: ResultsProps) {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	const methodItems = [
		{
			key: 'method',
			label: t('results.method-title'),
			children: (
				<ul className={styles.methodList}>
					<li>{t('results.method-labor')}</li>
					<li>{t('results.method-time')}</li>
					<li>{t('results.method-factors')}</li>
					<li>{t('results.method-benefit')}</li>
				</ul>
			),
		},
	];
	return (
		<div className={styles.results} aria-live="polite">
			<div className={styles.resultTop}>
				<h2>
					{t('results.for-company')} <span>{companyName}</span>
				</h2>
				<p>{t('results.description')}</p>
				<div className={styles.summaryGrid}>
					<div className={styles.summaryCard}>
						<span>{t('results.current-month')}</span>
						<strong>{formatRub(result.currentYear / 12)}</strong>
					</div>
					<div className={styles.summaryCard}>
						<span>{t('results.current-year')}</span>
						<strong>{formatRub(result.currentYear)}</strong>
					</div>
					<div className={styles.summaryCard}>
						<span>{t('results.hourly-cost')}</span>
						<strong>{formatRub(result.hourly)}</strong>
					</div>
				</div>
			</div>

			<div className={styles.resultBody}>
				<ScenarioCards result={result} />
				<TariffCard tariff={result.tariff} />
				<BreakdownTable result={result} />

				<Collapse className={styles.methodCollapse} ghost={false} items={methodItems} />

				<div className={styles.resultActions}>
					<Button
						type="primary"
						size="large"
						href="/registration"
						target="_blank"
						rel="noopener noreferrer"
					>
						{t('results.register')}
					</Button>
					<div className={styles.resultActionsRight}>
						<Button size="large" onClick={onShowChart}>
							{t('results.show-chart')}
						</Button>
						<Button size="large" onClick={onEdit}>
							{t('results.edit')}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
